import Link from 'next/link'
import React from 'react'

interface PropsType {
  route: string,
  label?: string
  showBorder?: boolean
}

const CustomNextLink = (props: PropsType) => {
  const { route, label, showBorder = false } = props

  return (
    <Link
      href={route}
      legacyBehavior
    >
      <a style={{ textDecoration: showBorder ? '' : 'none' }}>
        {label}
      </a>
    </Link>
  )
}

export default CustomNextLink
